var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    {
      staticClass:
        "align-items-center sticky-top pt-4 pb-3 bg-white border-bottom",
    },
    [
      _c("b-col", { attrs: { cols: "auto" } }, [
        _c("div", { staticClass: "pretty p-icon p-smooth mr-0" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.allDocumentsMarked,
                expression: "allDocumentsMarked",
              },
            ],
            staticClass: "valid",
            attrs: {
              id: "select-all-classifications",
              name: "select-all",
              type: "checkbox",
              disabled: !_vm.totalClassifications,
            },
            domProps: {
              checked: Array.isArray(_vm.allDocumentsMarked)
                ? _vm._i(_vm.allDocumentsMarked, null) > -1
                : _vm.allDocumentsMarked,
            },
            on: {
              change: function ($event) {
                var $$a = _vm.allDocumentsMarked,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.allDocumentsMarked = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.allDocumentsMarked = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.allDocumentsMarked = $$c
                }
              },
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "state p-primary" }, [
            _c(
              "i",
              {
                staticClass: "icon material-icons small-icon",
                staticStyle: { "font-size": "1em !important" },
              },
              [_vm._v("done")]
            ),
            _vm._v(" "),
            _c(
              "label",
              {
                staticClass: "text-light-gray hidden-text",
                attrs: { for: "select-all-classifications" },
              },
              [_vm._v(_vm._s(_vm.$t("global.actions.selectAll")))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "select-all d-sm-block d-md-none text-primary ml-2",
              },
              [_vm._v(_vm._s(_vm.$t("global.actions.selectAll")))]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("b-col", [
        _c(
          "div",
          { attrs: { id: "request-action-buttons" } },
          [
            _c("button-bar", {
              scopedSlots: _vm._u([
                {
                  key: "content",
                  fn: function () {
                    return [
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex pr-md-1",
                              class:
                                _vm.$i18n.locale === "fr-CA"
                                  ? "flex-xl-column flex-xxl-row"
                                  : "",
                            },
                            [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: {
                                        disabled: _vm.canRequest,
                                        title: _vm.$t(
                                          "documents.pleaseSelectDocumentsToRequest"
                                        ),
                                      },
                                      expression:
                                        "{\n                  disabled: canRequest,\n                  title: $t('documents.pleaseSelectDocumentsToRequest')\n                }",
                                    },
                                  ],
                                },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      class:
                                        _vm.$i18n.locale === "fr-CA"
                                          ? "mb-xl-2 ml-xl-2 mb-xxl-0 ml-xxl-0"
                                          : "",
                                      attrs: {
                                        id: "trigger-request-document",
                                        size: "sm",
                                        variant: "white",
                                        disabled: !_vm.canRequest,
                                      },
                                      on: { click: _vm.openBulkRequestModal },
                                    },
                                    [
                                      _c("icon", {
                                        staticClass: "pr-2",
                                        attrs: { name: "folder-open" },
                                      }),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            _vm.$t(
                                              "documents.requestDocumentsViaEmail"
                                            )
                                          ) +
                                          "\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "b-tooltip",
                                      rawName: "v-b-tooltip",
                                      value: {
                                        disabled: _vm.canDownload,
                                        title: _vm.$t(
                                          "documents.pleaseSelectDocumentsToRequest"
                                        ),
                                      },
                                      expression:
                                        "{\n                  disabled: canDownload,\n                  title: $t('documents.pleaseSelectDocumentsToRequest')\n                }",
                                    },
                                  ],
                                  ref: "triggerDownloadButtonContainer",
                                  staticClass: "ml-2",
                                },
                                [
                                  _c(
                                    "b-dropdown",
                                    {
                                      attrs: {
                                        id: "trigger-download-selected-documents",
                                        size: "sm",
                                        variant: "primary",
                                        disabled: !_vm.canDownload,
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("i", {
                                                staticClass:
                                                  "fa fa-download pr-2",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "documents.downloadSelectedAs",
                                                    { item: "" }
                                                  )
                                                ) +
                                                  "\n                    ..\n                  "
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ]),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click: _vm.handleDownloadAsZip,
                                          },
                                        },
                                        [
                                          _c("icon", {
                                            staticClass: "mr-2",
                                            attrs: { name: "file-archive-o" },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("documents.zipFile")
                                              ) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-dropdown-item",
                                        {
                                          on: {
                                            click:
                                              _vm.handlePreviewCombinedClick,
                                          },
                                        },
                                        [
                                          _c("icon", {
                                            staticClass: "mr-2",
                                            attrs: { name: "file-pdf-o" },
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.$t("documents.pdfFile")
                                              ) +
                                              "\n                  "
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "d-flex flex-row pl-md-0 mt-2 mt-xxl-0 justify-content-end",
                            },
                            [
                              _vm.hasFilteredSubmission
                                ? _c(
                                    "b-dropdown",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        id: "open-docs-to-lender-modal",
                                        disabled: !_vm.lendersSubmissionStatus,
                                        size: "sm",
                                        variant: "primary",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "button-content",
                                            fn: function () {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "documents.sendDocumentsToLender"
                                                    )
                                                  ) + "\n                "
                                                ),
                                              ]
                                            },
                                            proxy: true,
                                          },
                                        ],
                                        null,
                                        false,
                                        3978106967
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.filteredSubmissions,
                                        function (submission) {
                                          return _c(
                                            "b-dropdown-item",
                                            {
                                              key: submission.submissionId,
                                              on: {
                                                click: function ($event) {
                                                  return _vm.openDocumentsToLenderModal(
                                                    submission
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    submission.lenderName
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { size: "sm", variant: "white" },
                                  on: { click: _vm.openTagsModal },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.$t("documents.manageLabels")) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "trigger-template-modal",
                                  attrs: { size: "sm", variant: "white" },
                                  on: {
                                    click: _vm.showDocumentTemplateListModal,
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("documents.selectATemplate")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "ml-2",
                                  attrs: {
                                    id: "save-as-template",
                                    size: "sm",
                                    variant: "primary",
                                  },
                                  on: { click: _vm.handleSaveAsTemplateClick },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$t("documents.saveAsTemplate")
                                      ) +
                                      "\n              "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "dropdown-content",
                  fn: function () {
                    return [
                      _c(
                        "b-dropdown-item-button",
                        {
                          attrs: { disabled: !_vm.canRequest },
                          on: { click: _vm.openBulkRequestModal },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("documents.requestDocumentsViaEmail")
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item-button",
                        {
                          attrs: { disabled: !_vm.canDownload },
                          on: { click: _vm.handleDownloadAsZip },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("documents.downloadSelectedAs", {
                                  item: _vm.$t("documents.zipFile"),
                                })
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item-button",
                        {
                          attrs: { disabled: !_vm.canDownload },
                          on: { click: _vm.handlePreviewCombinedClick },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.$t("documents.downloadSelectedAs", {
                                  item: _vm.$t("documents.pdfFile"),
                                })
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-dropdown-divider"),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item-button",
                        { on: { click: _vm.showDocumentTemplateListModal } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("documents.selectATemplate")) +
                              "\n          "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item-button",
                        { on: { click: _vm.handleSaveAsTemplateClick } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("documents.saveAsTemplate")) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.previewCombinedModalVisible
        ? _c("preview-combined-modal", {
            ref: "previewCombinedModal",
            attrs: {
              "application-id": _vm.applicationId,
              "client-username": _vm.clientUsername,
              "client-details": _vm.clientDetails,
              "document-classifications": _vm.markedDocumentClassifications,
            },
            on: {
              hide: function ($event) {
                _vm.previewCombinedModalVisible = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("request-list-modal", {
        attrs: {
          "application-id": _vm.applicationId,
          "client-username": _vm.clientUsername,
          "preselected-request-list-name": _vm.preselectedRequestListName,
        },
        on: {
          "save-as": _vm.handleSaveAsRequestList,
          refresh: _vm.handleRefresh,
          hidden: _vm.clearDraftTemplate,
        },
      }),
      _vm._v(" "),
      _c("save-request-list-modal", {
        ref: "requestListModal",
        attrs: {
          "document-requests": _vm.requestListData,
          loading: _vm.savingRequestList,
        },
        on: { submit: _vm.handleCreateRequestList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }